import App from "@/App.vue";

export default [
  {
    path: "/login",
    name: "login",
    component: App,
    redirect: { name: "loginPage" },
    alias: "/",
    children: [
      {
        path: "",
        name: "loginPage",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Login.vue"),
        meta: {
          displayName: "Login - Lockton",
          requiresAuth: false
        }
      }
    ]
  },
  {
    path: "/recuperar-senha",
    name: "recover password",
    component: App,
    redirect: { name: "new password" },
    children: [
      {
        path: ":token",
        name: "new password",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Login.vue"),
        meta: {
          displayName: "Recuperar Senha - Lockton",
          requiresAuth: false
        }
      }
    ]
  }
];
